import Brieffeld from '@/types/Brieffeld';

export default class PatBriefInhalt {
    public patbriefinhalt_id: number | null = null;
    public patbrief_id: number | null = null;
    public feldnummer: number | null = null;
    public bezeichnung: string | null = null;
    public inhalt: string | null = null;

    constructor(feldnummer: number | null) {
        this.feldnummer = feldnummer;
    }

    public static from({ feldnummer, bezeichnung, vorgabe }: Brieffeld): PatBriefInhalt {
        return Object.assign(new this(feldnummer), {
            bezeichnung,
            inhalt: vorgabe,
        });
    }
}
